var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
export default function Main(_a) {
    var children = _a.children, fullWidth = _a.fullWidth;
    return _jsx(Container, { fullWidth: fullWidth, children: children });
}
var Container = styled.main(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 0px 0px 24px 24px;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  margin-top: 72px;\n  position: relative;\n  width: ", ";\n\n  @media screen and (min-width: 2800px) {\n    width: ", ";\n  }\n\n  @media screen and (max-width: 1200px) {\n    width: 100%;\n  }\n"], ["\n  align-items: center;\n  background-color: ", ";\n  border-radius: 0px 0px 24px 24px;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  margin-top: 72px;\n  position: relative;\n  width: ", ";\n\n  @media screen and (min-width: 2800px) {\n    width: ", ";\n  }\n\n  @media screen and (max-width: 1200px) {\n    width: 100%;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.layoutNeutral;
}, function (_a) {
    var fullWidth = _a.fullWidth;
    return (fullWidth ? '100%' : '1200px');
}, function (_a) {
    var fullWidth = _a.fullWidth;
    return (fullWidth ? '100%' : '2000px');
});
var templateObject_1;
